module.exports = __webpack_public_path__ + "ricardo_tripoli--0dd37f56.jpg";


//////////////////
// WEBPACK FOOTER
// ./_source/img/candidatos/ricardo_tripoli.jpg
// module id = 170
// module chunks = 0